import * as stylex from "@stylexjs/stylex";
import "../tokens.stylex.ts";
import { color, radius as radii, texture } from "../tokens.stylex.ts";
const REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";

/*
 * The highlight layer is twice the viewport wide and pinned to it
 * (`background-attachment: fixed`), so every skeleton on screen is lit by the
 * same band as it sweeps left to right — one wave across the page instead of
 * dozens of blocks pulsing on their own.
 */
const sweep = "x6t63sl-B";
const appear = "x18re5ia-B";
export type SkeletonRadius = "sm" | "md" | "lg" | "full";
export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: SkeletonRadius;
}

/** Placeholder for content that's still loading: a recessed, hatched bar under a sweeping highlight. */
export function Skeleton({
  width = "100%",
  height = 14,
  radius = "sm"
}: SkeletonProps) {
  return <span aria-hidden {...stylex.props(styles.base, radiuses[radius], styles.size(width, height))} />;
}
const styles = {
  base: {
    k1xSpc: "x1lliihq",
    kmuXW: "x2lah0s",
    ks0D6T: "x193iq5w",
    kWkggS: "xyez3s8",
    kKwaWg: "x2tlm20",
    kgSjnq: "x1wgpiiw",
    kz484i: "x1tq7sau",
    ku1ltF: "x1ecb0d1",
    kKVMdj: "x10y9p1t x1in4vjr",
    k44tkh: "x12nsstk xtzos97",
    kyAemX: "xirb7sz",
    ko0y90: "xjbfziq xg0664w",
    kWV6AL: "x18p89p5",
    $$css: true
  },
  size: (width: number | string, height: number | string) => [{
    kzqmXN: width != null ? "x5lhr3w" : width,
    kZKoxP: height != null ? "x16ye13r" : height,
    $$css: true
  }, {
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(width),
    "--x-height": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(height)
  }]
};
const radiuses = {
  sm: {
    kaIpWk: "x1y8ptio",
    $$css: true
  },
  md: {
    kaIpWk: "xoazux2",
    $$css: true
  },
  lg: {
    kaIpWk: "xlfxrz8",
    $$css: true
  },
  full: {
    kaIpWk: "x257jf6",
    $$css: true
  }
};